export default __webpack_public_path__ + "static/media/in-the-spotlight-ntf-store.f84acaab.jpg";